export enum AmountSeparater {
    COMMA = 'comma',
    DOT = 'dot',
    SPACE = 'space'
}